import { isEmpty } from 'lodash';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { AuditTagList } from '@shared/scenes/entity/components/fields/AuditTagEditField/AuditTagList';
import { AuditTagModal } from '@shared/scenes/entity/components/fields/AuditTagEditField/AuditTagModal';
import { API } from '@shared/types/api';
import { Trigger } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';

interface Props {
  component: API.AuditTagComponent;
  tags: string[];
  trigger: Trigger;
  anchorName: string;
  onChange(selectedTags: string[]): void;
  isReadOnly?: boolean;
}

/** @deprecated Use AuditTagEditField instead. */
export function WorkflowAuditTag({
  component,
  tags,
  trigger,
  onChange,
  isReadOnly,
  anchorName,
}: Props) {
  const tagList = !isEmpty(tags) && (
    <View row wrap shrinkWrap style={{ maxWidth: '100%' }} paddingBottom={1}>
      <AuditTagList tagOptions={component?.options} tags={tags} />
    </View>
  );

  return (
    <>
      <View paddingBottom={2}>
        <Text size="body1">{component?.label}</Text>
      </View>
      <View row paddingBottom={1}>
        <AuditTagModal
          anchorName={anchorName}
          onChange={onChange}
          trigger={trigger}
          label={i18n('card.blocks.question.answerButtonLabel')}
          // @ts-expect-error -- strict migration
          isMultiselect={component.multiselect}
          // @ts-expect-error -- strict migration
          tagOptions={component.options.filter(option => !option.archived)}
          tags={tags}
          isReadOnly={isReadOnly}
        >
          {tagList}
        </AuditTagModal>
      </View>
    </>
  );
}
